import React from 'react';
import styled from 'styled-components';

const Clickable = styled.div`
    display: inline-block;
    cursor: pointer;
`;

export default Clickable;



// WEBPACK FOOTER //
// ./components/Clickable.jsx